module.exports = __webpack_public_path__ + "img/122.fee52d9d.jpg";